import React from 'react'
import Manager from '../../public/components/Manager'
import SupplierChangeApplyDetail from './SupplierChangeApplyDetail'
Ext.require('Ext.Toast')


const config = {
    buttons: [
    ],
    columns: [
        { _text: '供应商信息修改申请单号', field: 'Number', search: true, minWidth: 200/* , tools: tipTools */ },
        { _text: '供应商编号', field: 'Supplier.Number', search: true, minWidth: 150, flex: 1, },
        { _text: '供应商名称', field: 'Supplier.SupplierName', search: true, minWidth: 150, flex: 1, },
        { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1, },
        { _datetime: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1, },
        { _: 'taskName', field: 'Task.TaskName' }
    ],
    onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierChangeApplyDetail {...props} id={data.id} taskName={data.taskName} />),
}

export default props => <Manager {...props} config={config} />